import React, { useEffect } from "react";
// Assure-toi que le chemin vers style.css est correct selon ton architecture
import "../style.css";

function Pre({ load, onDone }) {
  useEffect(() => {
    if (!load) return;

    /**
     * totalMs : Durée totale avant de cacher le preloader.
     * 3500ms permet de voir :
     * 1. Le nom complet (1s)
     * 2. La fusion ZA (1.2s)
     * 3. L'apparition de la ligne de circuit (0.8s)
     */
    const totalMs = 3500;

    const t = setTimeout(() => {
      onDone?.();
    }, totalMs);

    return () => clearTimeout(t);
  }, [load, onDone]);

  if (!load) return null;

  return (
    <div id="preloader">
      <div className="pre-container">

        {/* Section Texte : Gère la transformation Zaidi Arris -> ZA */}
        <div className="logo-wrapper">
          <span className="letter-z">
            Z<span className="hide-text">aidi</span>
          </span>

          {/* Cet espace invisible disparaît aussi pour coller le Z et le A */}
          <span className="hide-text">&nbsp;</span>

          <span className="letter-a">
            A<span className="hide-text">rris</span>
          </span>
        </div>

        {/* Section Graphique : La barre horizontale style circuit sous le ZA */}
        <div className="logo-line-container">
          <div className="logo-line"></div>
        </div>

      </div>
    </div>
  );
}

export default Pre;